"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripLeadingSlash = exports.stripTrailingSlashes = exports.parseHTML = exports.processParams = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
/**
 * Return the object key/values into a list of key=value delimited by &
 * @param parameters
 * @returns {string}
 */
function processParams(parameters) {
    const parameterList = Object.keys(parameters)
        .map(key => {
        return `${key}=${encodeURIComponent(parameters[key])}`;
    })
        .join('&');
    return parameterList;
}
exports.processParams = processParams;
function parseHTML(htmlString) {
    const html = window_or_global_1.default.document.createElement('div');
    html.innerHTML = htmlString;
    return html;
}
exports.parseHTML = parseHTML;
const trailingSlashRegex = /\/+$/;
/**
 * Strip all trailing slashes from URL or path
 * @param {string} url
 * @returns {string}
 */
function stripTrailingSlashes(url) {
    if (!url) {
        return '';
    }
    return url.replace(trailingSlashRegex, '');
}
exports.stripTrailingSlashes = stripTrailingSlashes;
/**
 *  Strip leading slash from path
 * @param {string} path
 * @returns {string}
 */
function stripLeadingSlash(path) {
    if (!path)
        return '';
    if (path && path[0] === '/') {
        return path.slice(1, path.length);
    }
    return path;
}
exports.stripLeadingSlash = stripLeadingSlash;
//# sourceMappingURL=url.js.map